/**
 *
 * Todo
 *
 * Display top level stats like:
 *
 *  - Total number of suggestions (medium or small )
 *  - Total number of prices (small)
 *  - Best  price across all suggestions (Big)
 *  -
 *
 *  - Total VE accepted(?)
 *
 *
 *  todo - developer and builder Widgets can be broken out...
 * */
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import React from "react";
import { BuilderVESummary, DeveloperVESummary } from "../ve/ve_model";
import { moneyFormatter } from "../../lib/formatters";
import {GoToVEButton, } from "../navButtons/navButton";



type BuilderWidgetProps = {
    ve_summary: BuilderVESummary;
};

function VEWidgetHeader() {
    return (
        <CardHeader>
            <CardTitle>
                <div className="flex justify-between items-center">
                    <div>VE Summary</div>
                    <GoToVEButton/>
                </div>
            </CardTitle>
        </CardHeader>
    );
}

export function BuilderVEWidget({ ve_summary }: BuilderWidgetProps) {
    return (
        <Card>
            <VEWidgetHeader />
            <CardContent className="h-64">
                <div className="columns-2 ">
                    <p>VE Items Suggested</p>
                    <p className="text-2xl">{ve_summary.num_suggestions}</p>
                </div>
                <br />
                <div className="columns-2">
                    Total VE
                    <p className="text-2xl">{ve_summary.num_priced}</p>
                </div>
                <br />
                <div className="columns-2">
                    Total Potential Savings ($)
                    <p className="text-xl">
                        {moneyFormatter.format(
                            ve_summary.best_savings_potential
                        )}
                    </p>
                </div>
                <br />
                <div className="columns-2">
                    Suggestions awaiting Input
                    <p className="text-xl">
                        {ve_summary.items_awaiting_pricing}
                    </p>
                </div>
            </CardContent>
        </Card>
    );
}

type DeveloperWidgetProps = {
    ve_summary: DeveloperVESummary;
};

export function DeveloperVEWidget({ ve_summary }: DeveloperWidgetProps) {
    if(!ve_summary){
        return <Card className="min-h-[355px]">
            <VEWidgetHeader />
            <CardContent>No Suggestions</CardContent>
        </Card>
    }
    return (
        <Card className="min-h-[355px]">
            <VEWidgetHeader />
            <CardContent className="h-64">
                <div className="columns-2 ">
                    <p>VE Items Suggested</p>
                    <p className="text-2xl">{ve_summary.num_suggestions}</p>
                </div>
                <br />
                <div className="columns-2">
                    Total VE
                    <p className="text-2xl">{ve_summary.num_priced}</p>
                </div>
                <br />
                <div className="columns-2">
                    Total Potential Savings ($)
                    <p className="text-xl">
                        {moneyFormatter.format(
                            ve_summary.best_savings_potential
                        )}
                    </p>
                </div>
                <br />
                <div className="columns-2">
                    Total VE suggested ($)
                    <p className="text-xl">
                        {moneyFormatter.format(
                            ve_summary.total_savings_suggested
                        )}
                    </p>
                </div>
            </CardContent>
        </Card>
    );
}
